<template>
  <div class="pricemark-container">
  <vggrid ref="xGrid" class="vggrid" :list="pusComList" flexname=""
          :cols="cols"
          :showfooter="false"
          :showPage="false" :resizable="true"
          @cellClick="cellClick">
    <template slot="btn" >

    </template>
  </vggrid>
    <!--v-if="project.projectstatus < 30"-->
<div v-if="+pusComList[0].psupricecommit !== 1 && project.projectstatus < 30 && +project.projectpricecomputebasis === 6" class="pricemarkhand-grid-btn">
  <div ><vxe-button type="primary" class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button></div>
  <div ><vxe-button type="primary" class="vxe-btn" @click="submit" :loading="btnLoading">提交</vxe-button></div>
</div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import PbrListForm from './pbrListForm'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pricemarkhandedit',
    props: {
      projectid: {},
      project: {},
      activeName: {
        default: ''
      }
    },
    mixins: [common],
    data () {
      return {
        // project: {},
        dialogVisible: false,
        psu: '',
        isEdit: true,
        pusComList: [],
        btnLoading: false,
        cols: [],
        pgModel: ''
      }
    },
    created () {
      this.getPsuComList()
    },
    activated() {
      this.getPsuComList()
    },
    mounted () {
    },
    watch: {
      activeName () {
        console.log(this.activeName)
        if(this.activeName === 'jgf') {
          this.getPsuComList()
        }
      }
    },
    components: {vggrid, PbrListForm},
    methods: {
      downAppend (row) {
        this.downFile(row.appendurl)
      },
      inputChange (row, e) {
        if (Number(e.target.value) > 100) {
          this.$message.warning('价格分不能大于100分！')
          e.target.value = ''
          return
        }
        let float = /^([+-]?)\d*\.\d+$|(^[0-9]\d*$)/
        // 只保留一位小数
        // let float = /^(\d{1,2}(\.\d{1})?|100)$/
        if (e.target.value && !(float.test(e.target.value))) {
          this.$message.warning('请输入正确的价格分，只保留一位小数！')
          e.target.value = ''
          return
        }
        row.psupriceas = e.target.value
        if (+this.project.projectpgstotalrule === 1) {
          // 价格转换分：转换公式（分值/分值总分）*权重
          row.psupriceasexchange = (this.pgModel ? ((Number(row.psupriceas) / 100) * Number(this.pgModel.pgratio)) : 0).toFixed(2)
        } else {
          row.psupriceasexchange = e.target.value
        }
      },
      inputDescChange (row, e) {
        row.psupriceaccording = e.target.value
      },
      // 获取价格总分数据
      async getPgByPrice () {
        this.pgModel = await request({
          url: '/xmgl/pg/getPgByPrice',
          method: "get",
          params: {
            projectid: this.projectid
          }
        })
      },
      getCols () {
          this.cols = [
            {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50},
            {field: 'comfullname', fieldtype: 'C', title: '供应商名称', calculExpr: '', addNewRowFlg: false},
            {field: 'psuamt', title: '比选报价', calculExpr: '', addNewRowFlg: false, width: 100},
            {
              title: '价格原始分', width: 100,
              slots: {
                default: 'default',
                default: ({row}) => {
                  if(+this.project.projectpricecomputebasis === 6 && +this.project.projectstatus < 30 && +row.psupricecommit !== 1) {
                    return [
                      <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                      value={row.psupriceas}  onChange={this.inputChange.bind(this, row)}></input>
                    ]
                  } else {
                    return row.psupriceas
                  }
                }
              }
            },
            {field: 'psupriceasexchange', title: '价格分', calculExpr: '', addNewRowFlg: false, width: 100},
            {
              title: '价格分计算依据',
              slots: {
                default: 'default',
                default: ({row}) => {
                  if(+this.project.projectpricecomputebasis === 6 && +this.project.projectstatus < 30 && +row.psupricecommit !== 1) {
                    return [
                        <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                      value={row.psupriceaccording}  onChange={this.inputDescChange.bind(this, row)}></input>
                    ]
                  } else {
                    return row.psupriceaccording
                  }
                }
              }
            }
          ]

      },
      async save () {
        let data = await request({
          url: '/xmgl/project/updatePsuListHandPrice',
          method: "post",
          data: this.pusComList
        })
        if (data.issuccess === 1) {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
        
      },
      submit () {
        this.$confirm('是否提交，提交后不可修改？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: '/xmgl/pg/updatePgsuPrice',
            method: "post",
            data: this.pusComList
          })
          if(data.issuccess === -2){
            this.$message.warning('请先保存')
          }
          else if (data.issuccess === 1) {
            this.$message.success('提交成功')
            this.getPsuComList()
          } else {
            this.$message.error('提交失败')
          }
        })
      },
      async getPsuComList () {
        this.getCols()
        let res = await request({
          url: '/xmgl/project/getPsuListByPIdHaveAppend',
          method: "get",
          params: {
            projectid: this.projectid,
            projectisqcheck: this.project.projectisqcheck,
            psupqcesresult: 1
          }
        })
        this.pusComList = res.data
        this.pusComList.map(v => {
          v.psuamt = utils.comdify(v.psuamt)
        })
        await this.getPgByPrice()
      },
      async cellClick (row) {
        // this.psu = row.row
      },
    }
  }
</script>
<style lang="scss" scoped>
  .pricemarkhand-grid-btn {
    display: flex;
    justify-content: flex-end;
    /*text-align: right;*/
    /*padding-right: 10px;*/
    padding-top: 10px;
    div {
      padding-left: 20px;
    }
  }

</style>
